import { Pipe } from "@angular/core";
import { CommonChecks } from "../../utilities/common-checks.utilities";

@Pipe({
    name: "noValue"
})
export class NoValuePipe {
    transform(input: any | undefined, replacementOverride: string = "-"): string {
        if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(input)) {
            return replacementOverride;
        } else {
            return input;
        }
    }
}